import { render, staticRenderFns } from "./icbc.vue?vue&type=template&id=4c5f887c&"
import script from "./icbc.vue?vue&type=script&lang=js&"
export * from "./icbc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ContentType3: require('D:/Project/kpwebsite/PC/components/content/content-type-3.vue').default})
